import React from "react";
import "./style.css";
import socialapp from "../../res/socialapp.png";
import { Link } from "react-router-dom";
import uidesign from "../../res/uidesign.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Card } from "react-bootstrap";

import Aos from "aos";
import "aos/dist/aos.css";
import handleViewport from "react-in-viewport";

class Projects extends React.Component {
  componentDidMount() {
    Aos.init({ duration: 500, once: true });
  }

  render() {
    return (
      <div className="projects" id="projects">
        <div className="projects-items">
          <div className="projects-header">
            <div data-aos="fade-in" className="projects-heading">
              <div>My recent</div>&nbsp;
              <span style={{ color: "rgb(255, 65, 31)" }}>work</span>
            </div>
          </div>

          <div data-aos="fade-in" className="projects-body">
            <Container fluid>
              <Row className="row">
                <Col className="col" xs={7} sm={7} md={7} lg={5} xl={4}>
                  <div className="projects-card">
                    <Card style={{ borderRadius: "12px" }}>
                      <a href="https://nextjs-startup-website.vercel.app">
                        <Card.Img
                          style={{
                            borderRadius: "12px",
                          }}
                          alt="NextJS Startup Website Image"
                          src="https://user-images.githubusercontent.com/74422938/126073161-0bc37591-38e4-44bc-b402-5b27ada351d2.png"
                        />
                      </a>
                    </Card>
                  </div>
                </Col>

                <Col className="col" xs={7} sm={7} md={7} lg={5} xl={4}>
                  <div className="projects-card">
                    <Card style={{ borderRadius: "12px" }}>
                      <a href="https://nextjs-blog-website-two.vercel.app">
                        <Card.Img
                          style={{
                            borderRadius: "12px",
                          }}
                          alt="NextJS Blog Website Image"
                          src="https://user-images.githubusercontent.com/74422938/125204886-05cd1000-e29d-11eb-90f5-67a4e5348df0.png"
                        />
                      </a>
                    </Card>
                  </div>
                </Col>

                <Col className="col" xs={7} sm={7} md={7} lg={5} xl={4}>
                  <div className="projects-card">
                    <Card style={{ borderRadius: "12px" }}>
                      {/* <Link to="/social-media-app"> */}
                      <a href="https://reactsocialapptutorial.web.app/">
                        <Card.Img
                          style={{
                            borderRadius: "12px",
                          }}
                          alt="ReactJS Social Media Website Image"
                          src="https://user-images.githubusercontent.com/74422938/124357308-78ecdb80-dc38-11eb-8630-2a2335ffb623.png"
                        />
                      </a>
                      {/* </Link> */}
                    </Card>
                  </div>
                </Col>

                <Col className="col" xs={7} sm={7} md={7} lg={5} xl={4}>
                  <div className="projects-card">
                    <Card style={{ borderRadius: "12px" }}>
                      <a href="https://nextjs-events-firebase-api-mongodb.vercel.app/">
                        <Card.Img
                          style={{
                            borderRadius: "12px",
                          }}
                          alt="NextJS Events Website Image"
                          src="https://user-images.githubusercontent.com/74422938/124357685-7d19f880-dc3a-11eb-8e79-fc1935f8ead0.png"
                        />
                      </a>
                    </Card>
                  </div>
                </Col>

                <Col className="col" xs={7} sm={7} md={7} lg={5} xl={4}>
                  <div className="projects-card">
                    <Card style={{ borderRadius: "12px" }}>
                      <a href="https://sagardalal15.github.io/reactjs-brilliant-clone/">
                        <Card.Img
                          style={{
                            borderRadius: "12px",
                          }}
                          alt="ReactJS Brilliant Website Image"
                          src="https://user-images.githubusercontent.com/74422938/124357515-7fc81e00-dc39-11eb-8d11-3137a3adb24e.png"
                        />
                      </a>
                    </Card>
                  </div>
                </Col>

                <Col className="col" xs={7} sm={7} md={7} lg={5} xl={4}>
                  <div className="projects-card">
                    <Card style={{ borderRadius: "12px" }}>
                      <a href="https://uidesign-268da.web.app">
                        <Card.Img
                          style={{
                            borderRadius: "12px",
                          }}
                          alt="ReactJS UI Design Website Image"
                          src={uidesign}
                        />
                      </a>
                    </Card>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    );
  }
}
//Using Viewport
const MySection3 = handleViewport(Projects, { rootMargin: "-50%" });

export default MySection3;
